module.exports = __webpack_public_path__ + "img/australian_legal_system_splash.40b5355c.jpg";